export enum ICON_SIZE {
    SMALL,
    MEDIUM,
    LARGE,
}
